import { MutableRefObject, useCallback } from 'react';
import { CustomRef, SectionId, getRefHeight } from './Navigation';

type Ref = MutableRefObject<HTMLDivElement | null>;

export const useScroll = (stickyRef: Ref) => {
  const scrollToSection = (ref: CustomRef, isStickyNavInactive?: boolean) => {
    if (!ref.element) {
      return;
    }

    if (ref.id === SectionId.Photos) {
      window.scrollTo({ behavior: 'smooth', top: 0 });
    } else {
      // If main nav is full height, offset requires altering
      const isMainNavFullHeight = window.scrollY === 0;

      const offset = isStickyNavInactive
        ? 0
        : isMainNavFullHeight
          ? getRefHeight(stickyRef) + 20
          : getRefHeight(stickyRef);

      window.scrollBy({
        behavior: 'smooth',
        top: ref.element.getBoundingClientRect().top - offset,
      });
    }
  };

  const scrollToRef = (ref: Ref, refAnchor: 'top' | 'bottom', isStickyNavInactive?: boolean) => {
    if (!ref.current) {
      return;
    }

    // If main nav is full height, offset requires altering
    const isMainNavFullHeight = window.scrollY === 0;

    const offset = isStickyNavInactive
      ? 0
      : isMainNavFullHeight
        ? getRefHeight(stickyRef) + 20
        : getRefHeight(stickyRef);

    window.scrollBy({
      behavior: 'smooth',
      top: ref.current.getBoundingClientRect()[refAnchor] - offset,
    });
  };

  const scrollToImage = useCallback(
    (image: Ref, container: Ref) => {
      if (!image.current || !container.current) {
        return;
      }

      const offset = getRefHeight(stickyRef);

      container.current.scrollBy({
        behavior: 'smooth',
        top: image.current.getBoundingClientRect().top - offset,
      });
    },
    [stickyRef]
  );

  return {
    scrollToSection,
    scrollToRef,
    scrollToImage,
  };
};
